import React from 'react';
import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';
import auto from '../assets/auto.mp4';

const Chapter3 = ({
  id,
  trackEvent,
}) => (
  <Chapter
    id={id}
    theme="green"
    title="21:00 uur, dinsdag"
    media={auto}
    onEnter={() => trackEvent(id)}
  >
    <Text>Je solliciteert naar een veelbelovende functie bij een klein bedrijf. Wat doe je daarna?</Text>
    <Scenario
      id="3"
      title="Wat doe je?"
      description="De vuilnisbak is vol en het is tijd om op te ruimen. Maar je hebt ook zin om te gamen..."
      scoreFirst={50}
      scoreSecond={-50}
      buttonTextFirst="Opruimen en afval recyclen"
      buttonTextSecond="Gamen"
      resultTextFirst="De overheid moedigt gedrag aan dat goed is voor het milieu."
      resultTextSecond="Jongeren die veel gamen en veel games kopen worden door de overheid gezien als lui."
      onCallback={(title, choice) => trackEvent(id, choice)}
    />
    <Box>
      <h3>Hoe berekent Alibaba de Sesame Credit score?</h3>
      <Text>Alibaba verstrekt leningen, is de grootste online marktplaats van het land en het beheert bijna al het Chinese betaalverkeer. En je betaalt dus bijna alles via diensten van Alibaba. Je kan er bijna niet omheen. Kortom: het bedrijf weet wat bijna alle Chinezen kopen.</Text>
      <Text>Al die gegevens worden verzameld en gecombineerd. Dat bepaalt jouw score.</Text>
    </Box>
  </Chapter>
);

export default Chapter3;



// WEBPACK FOOTER //
// ./src/chapters/Chapter3.js